import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
`;

export const Options = styled.div`
  margin-top: 32px;
`;

export const InputBox = styled.div`
  margin-bottom: 32px;
`;

export const DualInputs = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0;
  & > * {
    margin-bottom: 32px;
  }
  @media (min-width: 768px) {
    margin-bottom: 32px;
    & > * {
      margin-bottom: 0;
    }
    & > *:first-child {
      margin-right: 24px;
    }
  }
`;

export const Error = styled.span`
    color: red;
`;